import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import store from "../store";
import {setTemporaryNotifications} from "../notifications/actions";
import {defaultNotificationCreator} from "../../templates/Notifications";
import stocksExportService from "../../api/services/stocksExportService";
import {IColumnData, IRowData} from "../../constants/Table/interfaces";

interface IStocksExportReducer {
    rowData: IRowData[];
    columnData: IColumnData[];
    isNeedUpdateData: boolean;
    isStocksExportFormModalOpen: boolean;
    idFilter: number|null;
    skuFilter: string|null;
    barcodeFilter: string|null;
    sizeFilter: string|null;
    nameFilter: string|null;
    brandFilter: string|null;
    notesFilter: string|null;
}
const initialState: IStocksExportReducer = {
    rowData: [],
    columnData: [],
    isStocksExportFormModalOpen: false,
    isNeedUpdateData: false,
    idFilter: null,
    skuFilter: null,
    barcodeFilter: null,
    sizeFilter: null,
    nameFilter: null,
    brandFilter: null,
    notesFilter: null,
}

export const saveStocksExport = createAsyncThunk(
    'stocksExport/save',
    async (payload:any) => {
        try {
            const {data, isFullExport} = payload
            console.log(`updateStocksExport`, data);
            const res = await stocksExportService.saveSettings(data, isFullExport);

            if (res.status > 300) {
                throw new Error("Ошибка при запросе на сервер status: " + res.status)
            }

            store.dispatch(setIsStocksExportFormModalOpen(false))
            store.dispatch(setIsNeedUpdateData(true))
            store.dispatch(setTemporaryNotifications(
                //@ts-ignore
                defaultNotificationCreator({
                    title: "Настройки применены",
                    description: "",
                    iconType: "success"
                })
            ))
        } catch (error: any) {
            console.error(error.message)
            store.dispatch(setTemporaryNotifications(
                //@ts-ignore
                defaultNotificationCreator({
                    title: "Не удалось применить настройки отправки",
                    description: "Пожалуйста, обратитесь в поддержку",
                    iconType: "warning"
                })
            ))
        }
    }
)


const stocksExportStateSlice = createSlice({
    name: 'stocksExport',
    initialState,
    reducers: {
        /**
         * @description Setting rows
         * @param state
         * @param action
         */
        setRowData(state, action: PayloadAction<IRowData[]>) {
            state.rowData = action.payload;
        },
        editRowDataElement(state, action: PayloadAction<IRowData>) {
            state.rowData = state.rowData.map((element) =>
                element.id !== action.payload.id ? element : action.payload
            );
        },
        /**
         * @description Set flag that open/close stocks export form modal
         * @param state
         * @param action
         */
        setIsStocksExportFormModalOpen(state, action: PayloadAction<boolean>) {
            state.isStocksExportFormModalOpen = action.payload;
        },
        /**
         * @description Set flag that means is data must be updated
         * @param state
         * @param action
         */
        setIsNeedUpdateData(state, action: PayloadAction<boolean>) {
            state.isNeedUpdateData = action.payload;
        },
        setIdFilter(state, action: PayloadAction<number>) {
            state.idFilter = action.payload;
        },
        setSkuFilter(state, action: PayloadAction<string>) {
            state.skuFilter = action.payload;
        },
        setBarcodeFilter(state, action: PayloadAction<string>) {
            state.barcodeFilter = action.payload;
        },
        setSizeFilter(state, action: PayloadAction<string>) {
            state.sizeFilter = action.payload;
        },
        setNameFilter(state, action: PayloadAction<string>) {
            state.nameFilter = action.payload;
        },
        setBrandFilter(state, action: PayloadAction<string>) {
            state.brandFilter = action.payload;
        },
        setNotesFilter(state, action: PayloadAction<string>) {
            state.notesFilter = action.payload;
        },
    },
});

const stocksExport = stocksExportStateSlice.reducer;

export const {
    setIsStocksExportFormModalOpen,
    setIsNeedUpdateData,
    setRowData,
    editRowDataElement,
    setIdFilter,
    setSkuFilter,
    setBarcodeFilter,
    setSizeFilter,
    setNameFilter,
    setBrandFilter,
    setNotesFilter,
} = stocksExportStateSlice.actions;

export default stocksExport